import { routeTree } from "./route-tree"
import { type LazyComponentModule, type InitialRouteParams } from "./types"

export const lazyLoadComponent = (importFunc: () => Promise<LazyComponentModule>) => {
  return async () => {
    const { default: Component } = await importFunc()
    return { Component }
  }
}

export function replaceLocation(path: string) {
  if (window.location.pathname === path) {
    return
  }

  window.history.replaceState(window.history.state, "", path)
}

export function setInitialRoute({ error }: InitialRouteParams = {}) {
  if (error) {
    replaceLocation(routeTree.error.path())
    return
  }
  if (!error && window.location.pathname === routeTree.error.path()) {
    replaceLocation(routeTree.root.path())
  }
}
